export function setItem(key: string, data: string) {
  const d = encodeURI(`"${data}"`);
  localStorage.setItem(btoa(key), btoa(d));
}

export function getItem(key: string) {
  const dbKey = localStorage.getItem(btoa(key));
  if (!dbKey) {
    return null;
  }
  return JSON.parse(decodeURIComponent(atob(dbKey)));
}
